import {FC, useEffect, useState} from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as vendor from './VendorRedux'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({vendor: state.vendor})
const connector = connect(mapState, vendor.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const VendorInit: FC<PropsFromRedux> = (props) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // We should request user by authToken before rendering the application
  useEffect(() => {}, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(VendorInit)
